/**
 * Which discount code a checkout should use, in priority order.
 *
 * The URL wins. It is how redeeming a promo code arrives at the pricing page
 * (redeemOfferCode hands back /pricing?discount=...&package=...), so it is
 * both the most specific and the most deliberate of the three. It used not to
 * be read at all, which meant a customer who redeemed a code was quietly
 * charged full price.
 */
export function resolveDiscountCode(sources: {
  fromUrl?: string | null;
  userAssigned?: string | null;
  promotion?: string | null;
}): string | null {
  return sources.fromUrl?.trim() || sources.userAssigned?.trim() || sources.promotion?.trim() || null;
}
